// extracted by mini-css-extract-plugin
module.exports = {"landingCard":"login_landingCard__31Ip-","twitterButton":"login_twitterButton__1TwMR"};